import { makeStyles } from 'tss-react/mui'
import { colors } from '@/theme/colors.theme'

const useStyles = makeStyles()(() => {
  return {
    twoFactorCode: {
      width: '100%',
      '& .MuiInputBase-root': {
        height: 45,
        '& .MuiInputBase-input': {
          fontSize: 24,
          height: '25px !important',
          fontWeight: 'bold',
          textAlign: 'center',
          padding: '0px 0px 0px !important',
        },
      },
    },
    completed: {
      '& .MuiInputBase-input': {
        color: colors.blue,
      },
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: colors.blue,
      },
    },
    error: {
      '& .MuiInputBase-input': {
        color: colors.red,
      },
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: `${colors.red} !important`,
      },
    },
  }
})

export default useStyles
